"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Sentry = tslib_1.__importStar(require("@sentry/browser"));
const uuid_1 = require("uuid");
exports.default = {
    context: {},
    apm: null,
    /**
     * @deprecated Apm will be removed in next breaking version
     *
     */
    setApm(apm) {
        this.apm = apm;
    },
    generateUniqueIds(appName = 'sk1') {
        const sessionId = (0, uuid_1.v1)();
        const LS_KEY = `${appName}-browser-id`;
        const savedBrowserId = localStorage.getItem(LS_KEY);
        const browserId = savedBrowserId || (0, uuid_1.v1)();
        if (!savedBrowserId) {
            localStorage.setItem(LS_KEY, browserId);
        }
        this.addContext('sessionId', sessionId);
        this.addContext('browserId', browserId);
    },
    addContext(key, value) {
        this.context[key] = value;
        Sentry.configureScope(scope => {
            scope.setTag(key, `${value}`);
        });
    },
    /**
     * @deprecated Google analytics tracking will be removed in next breaking version
     *
     */
    sendGaEvent(type, description) {
        if (!window.ga) {
            return;
        }
        // Format context to 'key1:value1, key2:value2'
        const formattedContext = Object.keys(this.context)
            .map(key => {
            const item = this.context[key];
            return `${key}:${item}`;
        })
            .join(', ');
        window.ga('send', 'event', type, description, `${formattedContext}`);
    },
    /**
     * @deprecated Apm will be removed in next breaking version
     *
     */
    sendApmTransaction({ transactionType, error, labels }) {
        var _a;
        const transaction = (_a = this.apm) === null || _a === void 0 ? void 0 : _a.startTransaction(error, transactionType);
        if (!transaction) {
            return;
        }
        labels = Object.assign(Object.assign({}, labels), this.context);
        if (Object.keys(labels).length) {
            transaction.addLabels(labels);
        }
        transaction.end();
    },
    setupSentryUncaughtErrors() {
        /**
         * This is error tracking of last resort! If your code is causing Sentry to
         * log uncaught request errors, you are not responding to errors in your
         * codebase correctly.
         * All then's deserve a 'catch',
         * all async/awaits are lonely without a try/catch.
         */
        Sentry.addGlobalEventProcessor(function (event) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const message = event.message;
                if (message instanceof Response) {
                    const responseErrorEvent = Object.assign({}, event);
                    const json = yield message.json();
                    responseErrorEvent.message = json.message;
                    responseErrorEvent.exception = {
                        values: [
                            {
                                type: message.type,
                                value: `Uncaught Request error, url: ${message.url}, status: ${message.status}, statusText: ${message.statusText}, data: ${JSON.stringify(json)}`
                            }
                        ]
                    };
                    responseErrorEvent.request = {
                        url: message.url,
                        data: json
                    };
                    return responseErrorEvent;
                }
                return event;
            });
        });
    }
};
//# sourceMappingURL=Tracking.js.map